import './navBar.css'
import { Link, useMatch, useResolvedPath, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'

const navLinks = [
  { to: '/', label: 'ACCUEIL' },
  { to: '/ProvencePaie', label: 'A PROPOS' },
  { to: '/Mission', label: 'MISSIONS' },
  { to: '/Contact', label: 'CONTACTS' },
  { to: '/FaQ', label: 'FAQ' },
]

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setMenuOpen(false)
  }, [location.pathname])

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    onScroll()
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const handleToggle = () => setMenuOpen(prev => !prev)
  const handleNavLink = () => setMenuOpen(false)

  return (
    <header className={`sticky-top bg-dark shadow-sm nav-header ${scrolled ? 'nav-scrolled' : ''}`}>
      <div className="container position-relative">
        <nav className="navbar navbar-expand-md navbar-dark py-3 px-0 align-items-center" aria-label="Navigation principale">
          <Link to="/" className="navbar-brand d-flex align-items-center">
            <img
              className="bi me-4"
              role="img"
              aria-label="Logo Provence Paie"
              src={`${process.env.PUBLIC_URL}/images/provencePaie_logo.png`}
              style={{ height: '4rem' }}
            />
          </Link>

          <button
            className={`navbar-toggler d-md-none ${menuOpen ? '' : 'collapsed'}`}
            type="button"
            aria-controls="mobileNav"
            aria-expanded={menuOpen}
            aria-label="Toggle navigation"
            onClick={handleToggle}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="desktop-menu d-none d-md-flex align-items-center justify-content-between flex-grow-1">
            <ul className="navbar-nav mx-auto mb-0 d-flex align-items-center gap-4">
              {navLinks.map(({ to, label }) => (
                <li className="nav-item" key={to}>
                  <CostumeLink to={to}>{label}</CostumeLink>
                </li>
              ))}
            </ul>

            <div className="d-flex align-items-center">
              <a href="https://maps.app.goo.gl/piEdAPTHuBNXc4H57" target="_blank" rel="noreferrer" aria-label="Voir notre emplacement sur Google Maps">
                <img src={`${process.env.PUBLIC_URL}/images/map.png`} height="40" alt="Itinéraire vers Provence Paie" />
              </a>
            </div>
          </div>
        </nav>

        <div id="mobileNav" className={`mobile-menu d-md-none ${menuOpen ? 'open' : ''}`}>
          <ul className="navbar-nav mb-0 d-flex flex-column gap-4">
            {navLinks.map(({ to, label }) => (
              <li className="nav-item" key={to}>
                <CostumeLink to={to} onClick={handleNavLink}>
                  {label}
                </CostumeLink>
              </li>
            ))}
          </ul>

          <div className="mobile-map-link mt-4 text-center">
            <a href="https://maps.app.goo.gl/piEdAPTHuBNXc4H57" target="_blank" rel="noreferrer" aria-label="Voir notre emplacement sur Google Maps">
              <img src={`${process.env.PUBLIC_URL}/images/map.png`} height="40" alt="Itinéraire vers Provence Paie" />
            </a>
          </div>
        </div>
      </div>
    </header>
  )

  function CostumeLink({ to, children, onClick, ...props }) {
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch({ path: resolvedPath.pathname, end: true })

    return (
      <Link
        to={to}
        onClick={onClick}
        {...props}
        className={`nav-link text-white ${isActive ? 'active' : ''}`}
      >
        {children}
      </Link>
    )
  }
}
